import { get, post, put } from "../utils/axios/axios.config";
import CommonServices from "./common/common";

class WordCompletionGameService extends CommonServices {
  constructor() {
    super("/word-completion");
  }

  /**
   * Get active passage for word completion game
   */
  async getActivePassage(params) {
    try {
      const response = await get(`${this.url}/passage/active`, { params });
      return response;
    } catch (error) {
      throw error?.response?.data || error?.message;
    }
  }

  /** 
   * Get Leaderboard for word completion game
   */
  async getLeaderboard(params) {
    try {
      const response = await get(`${this.url}/leaderboard`, { params });
      return response;
    } catch (error) {
      throw error?.response?.data || error?.message;
    }
  }

  // ----------- Game Related API -------------
  /**
   * Start the game session
   */
  async startGameSession(data) {
    try {
      const response = await post(`${this.url}/game/start`, data);
      return response;
    } catch (error) {
      throw error?.response?.data || error?.message;
    }
  }

  /** 
   * Get user's game session
   */
  async getUserGameSession(params) {
    try {
      const response = await get(`${this.url}/game/session`, { params });
      return response;
    } catch (error) {
      throw error?.response?.data || error?.message;
    }
  }

  /** 
   * Update user's game session
   */
  async updateUserGameSession(sessionId, data) {
    try {
      const response = await put(`${this.url}/game/session/${sessionId}`, data);
      return response;
    } catch (error) {
      throw error?.response?.data || error?.message;
    }
  }

  /** 
   * Complete the game session
   */
  async completeGameSession(sessionId, data) {
    try {
      const response = await post(`${this.url}/game/complete/${sessionId}`, data);
      return response;
    } catch (error) {
      throw error?.response?.data || error?.message;
    }
  }
}

const wordCompletionGameService = new WordCompletionGameService();
export default wordCompletionGameService;
